const Actions = {
  Tabs: {
    OPEN: 'v.work-stock.actions.tabs.open',
    CLOSE: 'v.work-stock.actions.tabs.close',

    OPEN_DETAILS: 'v.work-stock.actions.tabs.open-details'
  },
  CHANGE_INDEX_FILTER: 'v.work-stock.actions.index-filters.change'
};

const Mutations = {
  CLEAR: 'v.work-stock.mutations.clear',
  Tabs: {
    ADD: 'v.work-stock.mutations.tabs.add',
    OPEN: 'v.work-stock.mutations.tabs.open',
    CLOSE: 'v.work-stock.mutations.tabs.close'
  },
  SET_INDEX_FILTER: 'v.work-stock.mutations.index-filters.set'
};

const Views = {
  Index: 'v.work-stock.views.index'
};

export default {
  Actions,
  Mutations,
  Views
};
